import { render, staticRenderFns } from "./CardLiveLayout.vue?vue&type=template&id=19b931f2&scoped=true&"
import script from "./CardLiveLayout.vue?vue&type=script&lang=js&"
export * from "./CardLiveLayout.vue?vue&type=script&lang=js&"
import style0 from "./CardLiveLayout.vue?vue&type=style&index=0&id=19b931f2&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "19b931f2",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VDivider } from 'vuetify/lib/components/VDivider';
import { VRadio } from 'vuetify/lib/components/VRadioGroup';
import { VRadioGroup } from 'vuetify/lib/components/VRadioGroup';
installComponents(component, {VDivider,VRadio,VRadioGroup})
